import { render, staticRenderFns } from "./ProductEditSellPricesModal.vue?vue&type=template&id=ee0e0d7a"
import script from "./ProductEditSellPricesModal.vue?vue&type=script&lang=ts"
export * from "./ProductEditSellPricesModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ee0e0d7a')) {
      api.createRecord('ee0e0d7a', component.options)
    } else {
      api.reload('ee0e0d7a', component.options)
    }
    module.hot.accept("./ProductEditSellPricesModal.vue?vue&type=template&id=ee0e0d7a", function () {
      api.rerender('ee0e0d7a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/products/ProductEditSellPricesModal.vue"
export default component.exports